<section class="login-section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="login-form">

                    <!-- server error  -->
                    <!-- <div class="alert alert-danger py-4 font-16 text-center text-error">
                        Server Msg
                    </div> -->
                    <br />
                    <h3 class="font-black ">{{"CHANGE_PASSWORD" | translate | titlecase }}</h3>
                    <!-- <p class="font-16 pb-3 pt-2 text-grey">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    </p> -->
                    <form class="row" [formGroup]="changePasswordForm" (change)="changePasswordFormChange()"
                        (submit)="changePasswordFormSubmit()">
                        <div class="form-group col-12">
                            <label class="font-bold">{{"CURRENT_PASSWORD" | translate | titlecase }}</label>
                            <input type="password" class="form-control" formControlName="currentPassword">
                        </div>
                        <div class="form-group col-12">
                            <label class="font-bold">{{"NEW_PASSWORD" | translate | titlecase }}</label>
                            <input type="password" class="form-control" formControlName="newPassword">
                        </div>
                        <div class="form-group col-12">
                            <label class="font-bold">{{"RE_NEW_PASSWORD" | translate | titlecase }}</label>
                            <input type="password" class="form-control" formControlName="confirmNewPassword">
                            <span class="font-16 text-error">{{confirmPasswordMsg}}</span>
                        </div>
                        <div class="form-group my-5 col-12">
                            <button type="submit" class="btn btn-primary btn-block"
                                [class.disabled]="!changePasswordValid">{{"CHANGE_PASSWORD" | translate | titlecase }}</button>
                            <button routerLink="/" class="btn btn-primary btn-block">{{"CANCEL" | translate | titlecase }}</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</section>